import { jwtDecode } from "jwt-decode"

/**
 * Validates if a JWT token is still valid (not expired)
 * @param token - The JWT token to validate
 * @returns true if the token is valid and not expired, false otherwise
 */
export const validateToken = (token: string): boolean => {
  try {
    const decoded = jwtDecode(token)
    return decoded.exp ? decoded.exp * 1000 > Date.now() : false
  } catch {
    return false
  }
}

/**
 * Gets a token for API requests with validation
 * This ensures we get the most up-to-date token from the store
 * and validates it before use
 * @param getTokenFromStore - Function to get token from store
 * @returns The token if valid, undefined if not found or invalid
 */
export const getValidTokenForRequest = (
  getTokenFromStore: () => string | undefined,
): string | undefined => {
  const token = getTokenFromStore()
  if (!token) {
    return undefined
  }

  if (!validateToken(token)) {
    return undefined
  }

  return token
}
